/*
 * @Author: seayon
 * @Date:   2017-04-16 16:59:40
 * @Last Modified by:   yw4295
 * @Last Modified time: 2017-08-03 12:53:14
 */
import { Message } from 'element-ui';
import NProgress from 'nprogress';
// Progress 进度条样式
import 'nprogress/nprogress.css';
import store from '../store';
// import apiConfig from '../config';
import { removeToken } from '../utils/auth';

export default [
  // 权限处理
  async (to, from, next) => {
    NProgress.start();
    // 无需登录的路由或已登录
    if (to.meta.auth === 0 || store.state.user.isGetUserInfo) {
      return next();
    }
    //      拉取用户信息和权限菜单,跳转授权已交给axios响应拦截器
    try {
      await store.dispatch('user/GetUserInfo');
      const menuList = await store.dispatch('updateUserAuthorities');
      // if (!menuList.length) {
      //   Message.error('操作无法执行，请先开通项目权限');
      //   next({ name: 'console.home' });
      //   return;
      // }
      if (!menuList.some((item) => item.action === to.name)) {
        if (to.name.split('.').length > 3) {
          Message.error('操作无法执行，请先开通功能权限');
        } else {
          Message.error('操作无法执行，请先开通菜单权限');
        }

        next({ name: 'console.home' });
        return;
      }
      return next();
    } catch (err) {
      Message.error('该用户无访问权限');
      removeToken();
      NProgress.done();
      // window.location.href = `${apiConfig[apiConfig.env].authBaseURL}/riskcontrol/oauth/login?redirect=${window.location.protocol}//${window.location.host}`;
    }
    return false;
  },
  // 其它处理
  (to, from, next) => {
    next();
  },
];
